export function filterLayerByPlanId(layerId, planId) {
  return ['all', ['==', 'object_type', layerId], ['==', 'planid', planId]];
}
export function filterLayerByPlanIds(layerId, planIds, versionsnr = 0) {
  const filter = [
    'all',
    ['match', ['get', 'object_type'], layerId, true, false],
    ['match', ['get', 'planid'], planIds, true, false],
  ];
  if (versionsnr) {
    filter.push(['match', ['get', 'versionsnr'], versionsnr, true, false]);
  }
  return filter;
}

export function filterHoveredLayerByLokalPlanId(
  hoveredLayerPlanId,
  lokalplanId
) {
  return [
    'all',
    ['==', 'planid', hoveredLayerPlanId],
    ['==', 'lokplan_id', lokalplanId],
  ];
}
